import { render, staticRenderFns } from "./ChatsRoomsComponents.vue?vue&type=template&id=6b7f9e7c&scoped=true&"
import script from "./ChatsRoomsComponents.vue?vue&type=script&lang=js&"
export * from "./ChatsRoomsComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.24._f07fc21c0eeec7f6e04fb4ae2769cbbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f9e7c",
  null
  
)

export default component.exports